var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c("el-date-picker", {
            attrs: {
              size: "small",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              "start-placeholder": "创建开始时间",
              "end-placeholder": "创建结束时间",
            },
            model: {
              value: _vm.searchTime,
              callback: function ($$v) {
                _vm.searchTime = $$v
              },
              expression: "searchTime",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 100, size: "small", placeholder: "订单编号" },
            model: {
              value: _vm.orderNo,
              callback: function ($$v) {
                _vm.orderNo = $$v
              },
              expression: "orderNo",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 50, size: "small", placeholder: "企业名称" },
            model: {
              value: _vm.enterpriseName,
              callback: function ($$v) {
                _vm.enterpriseName = $$v
              },
              expression: "enterpriseName",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 80, size: "small", placeholder: "企业ID" },
            model: {
              value: _vm.deptId,
              callback: function ($$v) {
                _vm.deptId = $$v
              },
              expression: "deptId",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 80, size: "small", placeholder: "商户单号" },
            model: {
              value: _vm.payOrderNo,
              callback: function ($$v) {
                _vm.payOrderNo = $$v
              },
              expression: "payOrderNo",
            },
          }),
          _c("el-input", {
            attrs: { maxlength: 80, size: "small", placeholder: "用户账号" },
            model: {
              value: _vm.mobile,
              callback: function ($$v) {
                _vm.mobile = $$v
              },
              expression: "mobile",
            },
          }),
          _c("el-date-picker", {
            attrs: {
              type: "date",
              size: "small",
              "value-format": "yyyy-MM-dd",
              placeholder: "下单时间",
            },
            model: {
              value: _vm.orderCreateDate,
              callback: function ($$v) {
                _vm.orderCreateDate = $$v
              },
              expression: "orderCreateDate",
            },
          }),
          _c("el-date-picker", {
            attrs: {
              type: "date",
              size: "small",
              "value-format": "yyyy-MM-dd",
              placeholder: "支付时间",
            },
            model: {
              value: _vm.payTime,
              callback: function ($$v) {
                _vm.payTime = $$v
              },
              expression: "payTime",
            },
          }),
          _c("el-date-picker", {
            attrs: {
              type: "date",
              size: "small",
              "value-format": "yyyy-MM-dd",
              placeholder: "退款时间",
            },
            model: {
              value: _vm.refundTime,
              callback: function ($$v) {
                _vm.refundTime = $$v
              },
              expression: "refundTime",
            },
          }),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                filterable: "",
                clearable: "",
                placeholder: "来源渠道",
              },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.appId,
                callback: function ($$v) {
                  _vm.appId = $$v
                },
                expression: "appId",
              },
            },
            _vm._l(_vm.channelList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "支付方式",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.payType,
                callback: function ($$v) {
                  _vm.payType = $$v
                },
                expression: "payType",
              },
            },
            [
              _c("el-option", { attrs: { label: "微信", value: 1 } }),
              _c("el-option", { attrs: { label: "支付宝", value: 2 } }),
              _c("el-option", { attrs: { label: "IOS内购", value: 5 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "订单状态",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.orderStatus,
                callback: function ($$v) {
                  _vm.orderStatus = $$v
                },
                expression: "orderStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "未支付", value: 1 } }),
              _c("el-option", { attrs: { label: "已支付", value: 2 } }),
              _c("el-option", { attrs: { label: "已退款", value: 3 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "退款状态",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.refundStatus,
                callback: function ($$v) {
                  _vm.refundStatus = $$v
                },
                expression: "refundStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "未申请", value: 0 } }),
              _c("el-option", { attrs: { label: "待处理", value: 1 } }),
              _c("el-option", { attrs: { label: "已退款", value: 2 } }),
              _c("el-option", { attrs: { label: "拒绝退款", value: 3 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "补单状态",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.fixStatus,
                callback: function ($$v) {
                  _vm.fixStatus = $$v
                },
                expression: "fixStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "未申请", value: 0 } }),
              _c("el-option", { attrs: { label: "待处理", value: 1 } }),
              _c("el-option", { attrs: { label: "已补单", value: 2 } }),
              _c("el-option", { attrs: { label: "已拒绝", value: 3 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                filterable: "",
                clearable: "",
                placeholder: "订单商品类型",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.productType,
                callback: function ($$v) {
                  _vm.productType = $$v
                },
                expression: "productType",
              },
            },
            _vm._l(_vm.productTypeList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.typeName, value: item.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "类别",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.categoryType,
                callback: function ($$v) {
                  _vm.categoryType = $$v
                },
                expression: "categoryType",
              },
            },
            [
              _c("el-option", { attrs: { label: "非续费", value: 0 } }),
              _c("el-option", { attrs: { label: "续费", value: 1 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "开票状态",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.invoiceStatus,
                callback: function ($$v) {
                  _vm.invoiceStatus = $$v
                },
                expression: "invoiceStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "未申请", value: 0 } }),
              _c("el-option", { attrs: { label: "待开票", value: 1 } }),
              _c("el-option", { attrs: { label: "已开票", value: 2 } }),
              _c("el-option", { attrs: { label: "开票失败", value: 3 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "业务状态",
                multiple: "",
                "collapse-tags": "",
              },
              on: { change: _vm.selectData },
              model: {
                value: _vm.orderType,
                callback: function ($$v) {
                  _vm.orderType = $$v
                },
                expression: "orderType",
              },
            },
            [
              _c("el-option", { attrs: { label: "前端购买", value: 1 } }),
              _c("el-option", { attrs: { label: "买dongle赠送", value: 2 } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("搜索")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "memberOrder_export",
                  expression: "'memberOrder_export'",
                },
              ],
              attrs: {
                icon: "el-icon-download",
                size: "small",
                type: "primary",
              },
              on: { click: _vm.exportList },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "table",
          attrs: { "element-loading-text": "加载中" },
        },
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              option: _vm.avueOption,
              "table-loading": _vm.loading,
              data: _vm.tableData,
              page: _vm.page,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "expand-change": _vm.expandChanges,
              "on-load": _vm.onLoad,
            },
            scopedSlots: _vm._u([
              {
                key: "isRenew",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          scope.row.isRenew == 0
                            ? "非续费"
                            : scope.row.isRenew == 1
                            ? "续费"
                            : ""
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
              {
                key: "orderType",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          scope.row.orderType == 1
                            ? "前端购买"
                            : scope.row.orderType == 2
                            ? "买dongle赠送"
                            : ""
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
              {
                key: "payType",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm._f("payType")(scope.row.payType)))]
                },
              },
              {
                key: "payStatus",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          scope.row.payStatus == 1
                            ? "未支付"
                            : scope.row.payStatus == 2
                            ? "已支付"
                            : scope.row.payStatus == 3
                            ? "已退款"
                            : ""
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
              {
                key: "refundReviewStatus",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("refundStatus")(scope.row.refundReviewStatus)
                      )
                    ),
                  ]
                },
              },
              {
                key: "supplementReviewStatus",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("fixStatus")(scope.row.supplementReviewStatus)
                      )
                    ),
                  ]
                },
              },
              {
                key: "invoiceReviewStatus",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("invoiceStatus")(scope.row.invoiceReviewStatus)
                      )
                    ),
                  ]
                },
              },
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    scope.row.freeRecordList.length !== 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-info",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openFreeDetail(
                                  scope.row.freeRecordList[0]
                                )
                              },
                            },
                          },
                          [_vm._v("赠品详情")]
                        )
                      : _vm._e(),
                    (scope.row.refundReviewStatus == 0 ||
                      scope.row.refundReviewStatus == 3) &&
                    scope.row.payStatus == 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberOrder_refund",
                                expression: "'memberOrder_refund'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-info",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openRefund(scope.row)
                              },
                            },
                          },
                          [_vm._v("申请退款")]
                        )
                      : _vm._e(),
                    (scope.row.refundReviewStatus == 0 ||
                      scope.row.refundReviewStatus == 3) &&
                    (scope.row.supplementReviewStatus == 0 ||
                      scope.row.supplementReviewStatus == 3) &&
                    scope.row.payStatus == 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberOrder_fix",
                                expression: "'memberOrder_fix'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-info",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openFix(scope.row)
                              },
                            },
                          },
                          [_vm._v("申请补单")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "补单申请",
            visible: _vm.showFix,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFix = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.checkItem, "label-width": "110px" },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(_vm._s(_vm.checkItem.id)),
              ]),
              _c("el-form-item", { attrs: { label: "用户账户" } }, [
                _vm._v(_vm._s(_vm.checkItem.mobile)),
              ]),
              _c("el-form-item", { attrs: { label: "订单商品名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.productName)),
              ]),
              _c("el-form-item", { attrs: { label: "支付方式" } }, [
                _vm._v(_vm._s(_vm._f("payType")(_vm.checkItem.payType))),
              ]),
              _c(
                "el-form-item",
                { staticClass: "form-upload-img", attrs: { label: "凭据" } },
                [
                  _vm.voucher
                    ? _c("img", { attrs: { src: _vm.voucher } })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "upload-box el-button el-button--primary el-button--small",
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("span", [_vm._v("点击上传文件")]),
                      _c("input", {
                        attrs: {
                          type: "file",
                          accept:
                            "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                          name: "file",
                        },
                        on: { change: _vm.handleUpload },
                      }),
                    ]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.fixRemark,
                      callback: function ($$v) {
                        _vm.fixRemark = $$v
                      },
                      expression: "fixRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberOrder_fix",
                      expression: "'memberOrder_fix'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: { click: _vm.submitFix },
                },
                [_vm._v("确认申请补单")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showFix = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款申请",
            visible: _vm.showRefund,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRefund = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.checkItem, "label-width": "110px" },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(_vm._s(_vm.checkItem.id)),
              ]),
              _c("el-form-item", { attrs: { label: "用户账户" } }, [
                _vm._v(_vm._s(_vm.checkItem.mobile)),
              ]),
              _c("el-form-item", { attrs: { label: "支付方式" } }, [
                _vm._v(_vm._s(_vm._f("payType")(_vm.checkItem.payType))),
              ]),
              _c("el-form-item", { attrs: { label: "支付金额" } }, [
                _vm._v(_vm._s(_vm.checkItem.payAmount) + " "),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "退款方式" } },
                [
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkItem.orderType === 1,
                          expression: "checkItem.orderType===1",
                        },
                      ],
                      attrs: { label: 1 },
                      model: {
                        value: _vm.refundType,
                        callback: function ($$v) {
                          _vm.refundType = $$v
                        },
                        expression: "refundType",
                      },
                    },
                    [_vm._v("退款不退货")]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkItem.orderType === 1,
                          expression: "checkItem.orderType===1",
                        },
                      ],
                      attrs: { label: 2 },
                      model: {
                        value: _vm.refundType,
                        callback: function ($$v) {
                          _vm.refundType = $$v
                        },
                        expression: "refundType",
                      },
                    },
                    [_vm._v("退款且退货")]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkItem.orderType !== 1,
                          expression: "checkItem.orderType!==1",
                        },
                      ],
                      attrs: { label: 2 },
                      model: {
                        value: _vm.refundType,
                        callback: function ($$v) {
                          _vm.refundType = $$v
                        },
                        expression: "refundType",
                      },
                    },
                    [_vm._v("退货")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款金额" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      disabled: _vm.checkItem.orderType === 2,
                      size: "small",
                      precision: 2,
                      step: 0.1,
                      min: 0,
                      max: 9999999999,
                    },
                    model: {
                      value: _vm.refundMoney,
                      callback: function ($$v) {
                        _vm.refundMoney = $$v
                      },
                      expression: "refundMoney",
                    },
                  }),
                  _vm._v(" 元\n      "),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款理由" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      placeholder: "请输入文字",
                    },
                    model: {
                      value: _vm.refundMark,
                      callback: function ($$v) {
                        _vm.refundMark = $$v
                      },
                      expression: "refundMark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberOrder_refund",
                      expression: "'memberOrder_refund'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: { click: _vm.submitRefund },
                },
                [_vm._v("确认申请退款")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showRefund = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "赠品详情",
            visible: _vm.showFreeDetail,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFreeDetail = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.freeDetail, "label-width": "130px" },
            },
            [
              _c("el-form-item", { attrs: { label: "附赠商品会员类型" } }, [
                _vm._v(_vm._s(_vm.freeDetail.freeType == 1 ? "企业会员" : "")),
              ]),
              _c("el-form-item", { attrs: { label: "附赠商品编号" } }, [
                _vm._v(_vm._s(_vm.freeDetail.productCode) + "}}"),
              ]),
              _c("el-form-item", { attrs: { label: "附赠商品名称" } }, [
                _vm._v(_vm._s(_vm.freeDetail.productName)),
              ]),
              _c("el-form-item", { attrs: { label: "合伙人账号" } }, [
                _vm._v(_vm._s(_vm.freeDetail.distributorAccount)),
              ]),
              _c("el-form-item", { attrs: { label: "绑定邀请码" } }, [
                _vm._v(_vm._s(_vm.freeDetail.distributorCode)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }